module.exports = __webpack_public_path__ + "static/img/avatar_r_3.29259ab8.png";